<script>
  import type { IUPicture } from "../types";

  export let data: IUPicture;
  export let width: number = 0;
</script>

<picture>
  {#if data?.sources}
    {#each data?.sources as source}
      <source
        media={source.media}
        srcset="{source.srcSet}&format=webp&quality=65"
      />
    {/each}
  {/if}

  <img
    src="{data?.src}?width={width}"
    alt={data?.alt}
    loading="lazy"
    {...$$restProps}
  />
</picture>

<!-- TOOD: add correct style="aspect-ratio: {data?.width} / {data?.height};" width={data?.width}
    height={data?.height} -->
